import { Grid } from '@mui/material';
import IForm from '../../../components/i-form/i-form.component';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import ITextField from '../../../components/text-component/textfield/i-textfield.component';
import { useState } from 'react';

const InputFormComponent = (props: any) => {
  const [inputCode, setInputCode]  = useState('');

  const onSubmit = (data: any) => {
    let inputData = {inputCode: inputCode, otherCode: data.otherCode};
    props.close(inputData);
  }

  const onCancel = () => {
    props.close();
  }

  const onInputChange = (e: any) => {
    setInputCode(e.target.value);
  }

  const getMainComponent = () => {
    return <Grid container spacing={1} width={350}>
      <Grid xs={6}>
        <IDropdown name='inputCode' label='Input Code' itemList={props.inputCodeValues} 
          required={true} onChangeEvent={(e: any) => onInputChange(e)} />
      </Grid>
      <Grid xs={6}>
        <ITextField name='otherCode' label='Other Code' required={'Other' === inputCode} disabled={'Other' !== inputCode}/>
      </Grid>
    </Grid>
  }

  return <IForm cancelNavigation={false} cancelForm={onCancel} submitForm={onSubmit} mainComponent={getMainComponent()}></IForm>
}

export default InputFormComponent;